var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";
const buttonVariants = cva([
    "text-xs font-bold tracking-wider uppercase whitespace-nowrap",
    "inline-flex items-center justify-center gap-2 shrink-0 rounded-full cursor-pointer outline-none transition-colors duration-300",
    "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
    "disabled:pointer-events-none disabled:opacity-50",
    "aria-invalid:ring-destructive/20 aria-invalid:border-destructive dark:aria-invalid:ring-destructive/40 ",
    "[&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0",
], {
    variants: {
        variant: {
            default: "bg-button text-button-foreground hover:bg-muted focus:bg-muted",
            destructive: [
                "bg-destructive text-destructive-foreground",
                "hover:bg-destructive-hover focus:bg-destructive-hover focus-visible:ring-destructive-foreground/20",
                "dark:focus-visible:ring-destructive-foreground/40",
            ],
            outline: [
                "border bg-background",
                "hover:bg-accent hover:text-accent-foreground",
                "dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
            ],
            primary: "bg-primary text-primary-foreground hover:bg-primary-hover focus:bg-primary-hover",
            secondary: "bg-secondary text-secondary-foregroun hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
            link: "text-primary underline-offset-4 hover:underline",
        },
        size: {
            default: "h-9 px-4 py-2 has-[>svg]:px-3",
            sm: "h-8 gap-1.5 px-3 has-[>svg]:px-2.5",
            lg: "h-10 px-6 has-[>svg]:px-4",
            icon: "size-9",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
function Button(_a) {
    var { className, variant, size, asChild = false } = _a, props = __rest(_a, ["className", "variant", "size", "asChild"]);
    const Comp = asChild ? Slot : "button";
    return (_jsx(Comp, Object.assign({ "data-slot": "button", className: cn(buttonVariants({ variant, size }), className) }, props)));
}
export { Button, buttonVariants };
